
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @copyright Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @version 1.0.0
 * @changelog
 *  2023-01-18 (1.0.0) (jhoward)
 *    - <show-list> gathers show and package data from the server.
 *    - <show-list> renders shows to match the output of the server-side rendered show list.
 */

import {defineComponent} from "vue";
import Show from "./ShowComponent.vue";

declare global {
  interface Window {
    updateLastFooterRender: (newValue: number) => void;
  }
}

interface ShowApiResponse {
  STATUS: string;
  DATA: {
    SHOWS?: Show[];
  }
}

export default defineComponent({
  name: "ShowList",
  components: {Show},
  data() {
    return {
      shows: [] as Show[],
      packages: [] as string[],
      isLoading: true,
    };
  },
  mounted() {
    fetch(
        '/library/api/shows.php?ACTION=GET_SHOWS',
        {
          method: 'GET',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          redirect: 'follow'
        })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if ('SUCCESS' === json.STATUS && 'SHOWS' in json.DATA) {
            this.shows = json.DATA.SHOWS;
          }
        })
        .finally(() => {
          this.isLoading = false;
          setTimeout(() => {
            window.updateLastFooterRender(-1);
            window.dispatchEvent(new Event('resize'));
          }, 1000);
        })
        .catch(e => {
          console.log(e);
        });


    fetch(
        '/library/api/shows.php?ACTION=GET_PACKAGES',
        {
          method: 'GET',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          redirect: 'follow'
        })
        .then(response => {
          return response.json();
        })
        .then(json => {
          if ('SUCCESS' === json.STATUS && 'PACKAGES' in json.DATA) {
            this.packages = json.DATA.PACKAGES;
          }
        })
        .catch(e => {
          console.log(e);
        });
  },
})
